import React from "react"
const Home = React.lazy(() => import('../pages/home/Container'))
const Scanner = React.lazy(() => import('../pages/scanner/Container'))
const Results = React.lazy(() => import('../pages/results/Container'))
const PrivacyPolicy = React.lazy(() => import('../pages/privacy-policy/Container'))
const NotFound = React.lazy(() => import('../pages/not-found/Container'))

const PUBLIC_ROUTES = [
    {
        path: '/',
        exact: true,
        Component: <Home />,
        name: 'Home'
    },
    {
        path: '/scanner',
        exact: true,
        Component: <Scanner />,
        name: 'Scanner'
    },
    {
        path: '/results',
        exact: true,
        Component: <Results />,
        name: 'Results'
    },
    {
        path: '/privacy-policy',
        exact: true,
        Component: <PrivacyPolicy />,
        name: 'PrivacyPolicy'
    },
    {
        path: '*',
        exact: false,
        Component: <NotFound />,
        name: 'NotFound'
    },
];

export default PUBLIC_ROUTES;